export default __webpack_public_path__ + "static/media/group-8315.3cfbb033.png";